import { memo } from "react";
import VideoTag from "./players/videoTag";
import { IPlayerCoreProps } from "interfaces";

const PlayerCore = ({ isMultiLive }: IPlayerCoreProps) => {
    return (
        <>
            <VideoTag isMultiLive={isMultiLive} />
        </>
    );
};

export default memo(PlayerCore);
